export class SensitivityAnnotationsDetails {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "hasSensitivityAnnotations",
            "baseName": "hasSensitivityAnnotations",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "isOverridden",
            "baseName": "isOverridden",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SensitivityAnnotationsDetails.attributeTypeMap;
    }
    constructor() {
    }
}
